const headTag = document.getElementsByTagName('head')[0]
const libraries = {}

libraries.productLightBox = {
  isLoading: false,
  isLoaded: false,
  loadPromise: null,
  scriptUrl: 'https://cdn.adimo.co/scripts/lightboxv2.min.js'
}
libraries.recipeWidget = {
  isLoading: false,
  isLoaded: false,
  loadPromise: null,
  scriptUrl: 'https://cdn.adimo.co/scripts/ramsay.min.js'
}
libraries.productPriceFirst = {
  isLoading: false,
  isLoaded: false,
  loadPromise: null,
  scriptUrl: 'https://cdn.adimo.co/scripts/priceFirst.min.js'
}

/* eslint-disable */
const getLibrary = (url) => {
  return new Promise((resolve, reject) => {
    const scriptHTML = document.createElement('script')

    scriptHTML.type = 'text/javascript'
    scriptHTML.async = true
    scriptHTML.src = url

    scriptHTML.onload = function () {
      resolve(url)
    }
    scriptHTML.onerror = function () {
      reject('error')
    }

    headTag.appendChild(scriptHTML)
  })
}

const loadMap = (scriptUrl) => {
  return getLibrary(scriptUrl)
}

export default {
  async loadAdimo(scriptType) {
    if (libraries[scriptType].isLoading || libraries[scriptType].isLoaded) {
      return libraries[scriptType].loadPromise
    }

    libraries[scriptType].isLoading = true

    try {
      libraries[scriptType].loadPromise = loadMap(libraries[scriptType].scriptUrl)
      await libraries[scriptType].loadPromise
      libraries[scriptType].isLoaded = true
    } finally {
      libraries[scriptType].isLoading = false
    }
  }
}
/* eslint-enable */
